import React, { FC } from "react";
import { observer } from 'mobx-react-lite';
import cx from 'classnames';
import { getInstructionDisplay } from '../../../../../constants/InstructionLabels';
import { SequenceReferenceTreeNodeLabel, TreeNode, TreeNodeLabel } from '../TreeNode';
import { InstructionNodeProps } from './InstructionNodeFactory';
import { FSMInstruction } from '../../../../../machinelogic/types';
import { InstructionStateStatus } from "../../../../../machinelogic/constants";

interface FSMInstructionProps extends InstructionNodeProps {
  instruction: FSMInstruction;
}

export const FsmNode: FC<FSMInstructionProps> = observer(({instruction, isSelected, isInvalid, onClick}) => {

  const instructionDisplay = getInstructionDisplay(instruction);

  const instructionLabel = <TreeNodeLabel
    icon={instructionDisplay.icon}
    name={instructionDisplay.name}
    isSelected={isSelected}
    isInvalid={isInvalid}
    onClick={onClick}
  />;

  return (
    <TreeNode
      title={instructionLabel}
      isCollapsible
    >
      { instruction.parameters.states.map((state) => {
        const activeState = instruction.state?.subInstructionState?.activeStateName === state.stateName;
        return (
          <TreeNode
            key={state.stateName}
            title={<TreeNodeLabel name={state.stateName} onClick={onClick} />}
          >
            {state.actionSequenceName &&
                  <TreeNode
                    title={
                      <SequenceReferenceTreeNodeLabel
                        name={state.actionSequenceName}
                        onClick={onClick}
                        sequenceName={state.actionSequenceName}
                      />
                    }
                    titleClassName={ cx({
                      'ml_animated_background_tree running': activeState && instruction.state.status === InstructionStateStatus.RUNNING,
                      'ml_animated_background_tree waiting': activeState && instruction.state.status === InstructionStateStatus.WAITING,
                      'ml_animated_background_tree paused': activeState && instruction.state.status === InstructionStateStatus.PAUSED
                    }) }
                  />}
          </TreeNode>
        );
      })
      }
    </ TreeNode>
  );
});
